import React from "react";

function MonthlyReporting() {
  return <div></div>;
}

export default MonthlyReporting;
